import APIService from './APIService'

const api = APIService()

export const getBillingList = () => api.get('/transactions')

export const showInvoice = id => api.get(`/transactions/${id}/download-invoice`)

export const createBillingPortalSession = () => api.post('/subscriptions/billing-portal')

export const getSubscriptionPaymentStatus = () => api.get('/subscriptions/payment-status')

export const getSubscriptionExpiryAlerts = () => api.get('/subscriptions/expiry-alerts')
